module.exports = __webpack_public_path__ + "img/icon225.f6cc29ce.png";